namespace GeniuzPOS.QRreport {
    export class QDayDataColumns {
        static columnsKey = 'QRreport.QDayData';
    }
}
